<template>
	<div class="expert-record max-content">
        <top title="专家视频"></top>
		<div class="video">
			<video :src="videoData.video_url" controls  autoplay="autoplay" loop width="100%" height="220px"></video>
			<p>{{videoData.name}}</p>
		   
		</div>
		<div class="expert">
            <div class="left">
                <div>
                    <img v-if="photo" :src="photo"/>
                    <img v-else src="@/assets/images/defaultHead.png"/>
                </div>
                <div class="info">
                    <p>{{name}}</p>
                    <span>{{formatTime(videoData.start_at)}}</span></div>
                </div>
            <div class="right"></div>
        </div>
        <!-- <div class="tabbar">
            <div>
                <img src="@/assets/images/System/see_icon.png"/>
                <p>浏览 96</p>
            </div>
            <div>
                <img src="@/assets/images/System/like_icon.png"/>
                <p>点赞 9</p>
            </div>
            <div>
                <img src="@/assets/images/System/wechat_icon.png"/>
                <p>微信</p>
            </div>
            <div>
                <img src="@/assets/images/System/share_icon.png"/>
                <p>朋友圈</p>
            </div>
        </div> -->
    <div class="comment">
        <div class="title"><span></span>全部评论</div>
        <div class="one-piece" v-for="(value,index) in comments" :key="index">
            <!-- <div class="message"> -->
            <div class="image">
                    <img v-if="value.avatar" :src="value.avatar"/>
                    <img v-else src="@/assets/images/defaultHead.png"/>
            </div>
            <div class="message">
                <p >{{value.nickname}}</p>
                <p>{{value.content}}</p>
                <span>{{formatTime(value.created_at)}}<div class="reply-button" @click="showReply(value.nickname,value.id,value.id)">回复</div></span>
                <hr color="#F8F8F8">
                <div v-if="value.floors&&show_all_reply[index]">
                <div class="floors" v-for="(item,index) in value.floors" :key="index">
                <div class="reply" >
                    <div class="image">
                        <img v-if="item.avatar" :src="item.avatar"/>
                        <img v-else src="@/assets/images/defaultHead.png"/>
                    </div>
                    <div class="name">
                        <p >{{item.nickname}}</p>
                    </div>  
                </div>
                <p>回复<span class="replyto">@{{item.reply_user_name}}</span>:{{item.content}}</p>
                <span>{{formatTime(item.created_at)}}<div class="reply-button" @click="showReply(item.nickname,value.id,item.id)">回复</div></span>
                <hr color="#F8F8F8">
                </div>
                </div>
                <div v-else-if="value.floors.length>0">
                <div class="floors" v-for="(item,index) in value.floors.slice(0,1)" :key="index">
                <div class="reply" >
                    <div class="image">
                        <img v-if="item.avatar" :src="item.avatar"/>
                        <img v-else src="@/assets/images/defaultHead.png"/>
                    </div>
                    <div class="name">
                        <p >{{item.nickname}}</p>
                    </div>  
                </div>
                <p>回复<span class="replyto">@{{item.reply_user_name}}</span>:{{item.content}}</p>
                <span>{{formatTime(item.created_at)}}<div class="reply-button" @click="showReply(item.nickname,value.id,item.id)">回复</div></span>
                <hr color="#F8F8F8">
                </div>
                <div class="reply">
                    <p class="extend-reply" @click="extendReply(index)">展开剩余{{value.floors.length-1}}条回复</p>
                </div>
                </div>
            </div>
        </div>
    </div>
    <div class="comment-input flex" style="max-width:580px;">
			<input type="text" placeholder="说点什么..."   ref="commentInput" v-model="content">
			<button @click="sendDiscuss">发送</button>
	</div>
    <van-overlay :show="show" @click="closeShow">
        <div class="wrapper">
            <div class="block" @click.stop>
                <p>回复@{{reply_form.reply_to}}</p>
                <van-field 
                v-model="reply_form.content" 
                placeholder="发布你的回复"
                type="textarea"
                maxlength="300"
                show-word-limit
                ></van-field>
                <van-button round color="#d2020d" size="small" @click="reply()">回复</van-button>
            </div>
        </div>
    </van-overlay>
	</div>
</template>
<script>
	import {PersoanalUserInfo,RecordComment, RecordCommentList} from '../../../config/interface.js'
    import Top from '../components/Top'
	export default{
        components:{
            Top
        },
		data(){
			return{
				userInfo:'',
                content:'',
                id:this.$route.query.id,
                name:this.$route.query.name,
                videoData:{},
                comments:[],
                photo:this.$route.query.avater,
                show:false,
                reply_form:{
                    reply_to_name:'',
                    top_floor_id:'',
                    floor_id:'',
                    content:''
                },
                show_all_reply:[]

			}
		},
        created(){
        },
		mounted(){
            this.getRecordDetail();
            this.getComments();
				let keyTimer = null;
				document.body.addEventListener('focusin', () => {
					//软键盘弹起事件
					clearInterval(keyTimer);
				});
				document.body.addEventListener('focusout', () => {
				    // 软键盘关闭事件
					window.scrollTo(0, 0);
				    keyTimer = setTimeout(() => {
				      if (window.pageYOffset > 0) {
				        window.scrollTo(0, 0);
				      }
				    }, 200);
				})
		},
		methods:{
            //得到用户信息
            getUserInfo(){
                const url=PersoanalUserInfo;
                let params={};
                const method='POST';
                fetch(url,params,method)
                .then((res)=>{
                    if(res.code==0){
                        let data=res.data;
                        localStorage.setItem('userInfo',JSON.stringify(data));
                        this.$store.dispatch('storageUserInfo',data);	
                        this.userInfo=data;
                        if(this.userInfo.mobile_status==1){
                        }
                        else{
                            common.toast('未绑定手机',1000,'fail',()=>{
                                this.$router.push({
                                    path:'/vascularNews/user/login',
                                    query:{url:window.location.href}
                                })
					        })	
                        }
                    }
                })
            },
            sendDiscuss(){
                const url=RecordComment;
                const method='POST';
                const params={
                    top_floor_id:0,
                    floor_id:0,
                    content:this.content,
                    chapter_detail_id:this.id
                };
                fetch(url,params,method)
                .then((res)=>{
                    if(res.code==0){
                        this.content='';
                        this.getComments();
                    }
                })

            },
            getRecordDetail(){
                const url='/webapi/chapter_details/'+this.id;
                const method='GET';
                const params={};
                fetch(url,params,method)
                .then((res)=>{
                    if(res.code==0){
                        this.videoData=res.data;
                    }
                })
            },
            getComments(){
                const url='/webapi/chapter_details/'+this.id+'/detail_comments';
                const method='GET';
                const params={};
                fetch(url,params,method)
                .then((res)=>{
                    if(res.code==0){
                        this.comments=res.data.data;
                        this.show_all_reply=[];
                        for(let i=0;i<this.comments.length;i++){
                            if(this.comments[i].floors.length<2){
                                this.show_all_reply.push(true);
                            }
                            else{
                                this.show_all_reply.push(false);
                            }
                        }
                        console.log(this.show_all_reply);
                    }
                })
            },
            reply(){
                const url=RecordComment;
                const method='POST';
                const params={
                    top_floor_id:this.reply_form.top_floor_id,
                    floor_id:this.reply_form.floor_id,
                    content:this.reply_form.content,
                    chapter_detail_id:this.id
                };
                fetch(url,params,method)
                .then((res)=>{
                    if(res.code==0){
                        this.getComments();
                        this.clearReplyForm();
                        this.show=false;
                    }
                })
            },
            showReply(name,top_floor_id,floor_id){
                this.show=true;
                this.reply_form={
                    reply_to:name,
                    top_floor_id:top_floor_id,
                    floor_id:floor_id,
                    content:''
                }
            },
            clearReplyForm(){
                this.reply_form={
                    reply_to_name:'',
                    top_floor_id:'',
                    floor_id:'',
                    content:''
                }
            },
            closeShow(){
                this.show=false;
                this.clearReplyForm();
            },
            formatTime(time){
                if(time!=null){
                    return time.slice(0,16);
                }
                return '';
            },
            extendReply(index){
                this.$set(this.show_all_reply,index,true)
            }
			
		}
	}
</script>
<style lang="scss">
	.expert-record{
		display: flex;
		flex-direction: column;
		height:100%;
		.video{
			.viewNumber{
				position: absolute;
				top:0;
				left:0;
				z-index:1000;
				width:100%;
				height:20px;
				line-height: 20px;
				text-align: center;
				font-size:12px;
				color:#fff;
				background:rgba(17,17,17,0.4);
			}
			p{
                background: white;
				padding:10px 18px;
				font-size:20px;
				color:$color-black;
                color: #474747;
			}
		}
		.swiper-img{
			width:100%;
			img{
				width:100% !important;
			}
		}
        .expert{
            display: flex;
            padding: 15px;
            background: white;
            .left{
                width:75%;
                display: flex;
                img{
                    width: 1.2rem;
                    border-radius: 50%;
                    margin-right: 15px;
                }
                p{
                    font-size: 16px;
                    color: #474747;
                }
                span{
                    line-height: 0.8rem;
                    color: #C6C7C8;
                    font-size: 16px;
                    
                }
            }
            .right{
                width:25%;
                button{
                    background: $color-main;
                    color: white;
                    font-size:16px;
                    padding:7px 20px;
                    border-radius: 20px;
                    border:none;
                }
            }

        }
        .tabbar{
            background: white;
            display: flex;
            padding-bottom: 15px;
            div{
                width:25%;
                text-align: center;
                color: #C6C7C8;
                img{
                    width:20px;
                    height: 20px;
                }
            }
        }
        .comment{
            margin-top:10px;
            padding:0 15px;
            padding-bottom:44px ;
            background: white;
            .title{
                font-size: 20px;
				line-height:50px;
					span{
						display: inline-block;
						vertical-align:0px;
						height:14px;
						border-left:5px solid $color-main;
						margin-right:5px;
					}
            }
            .one-piece{
                font-size: 16px;
                display: flex;
                color: #474747;
                margin-top:10px ;
                p{
                    padding-bottom: 10px;
                }
                span{
                    color: #C6C7C8;
                }
                hr{
                    width:100%;
                    margin-top:10px ;
                }
                .reply-button{
                    display: inline;
                    margin-left:10px ;

                }
                .image{
                    width:16%;
                    img{
                        width:1.2rem;
                        border-radius: 50%;
                    }
                }
                .message{
                    width:80%;
                    .replyto{
                        color: $color-main;
                    }
                }
                .reply{
                    display: flex;
                    margin-top:15px ;
                    .name{
                        line-height: 1.2rem;
                        padding-left:10px;
                    }
                    
                }
                .extend-reply{
                    color: #71A2F6;
                }
            }
            
        }
        .comment-input{
			position:fixed;
			bottom: 0px;
            width: 100%;
			height:44px;
			padding:5px 15px;
			align-items:center;
			background-color:white;
				input{
					line-height:34px;
					padding-left:5px;
					flex:1;
					border:0px;
					font-size:15px;
					color:#000;
                    background-color:#f4f4f4;
                    border-radius: 20px;
                    padding-left:10px;
				}
				button{
					margin-left:5px;
					/*width:52px;*/
					height:28px;
					border:0px;
					padding:0 10px;
					line-height:28px;
					text-align:center;
					background-color:white;
					font-size: 16px;
					color:$color-main;
				}
			}
        .van-overlay{
            .wrapper {
                display: flex;
                align-items: center;
                justify-content: center;
                height: 100%;
            }
            .block {
                width: 80%;
                height: 200px;
                background-color: #fff;
                p{
                    padding:10px;
                    font-size:14px;
                }
                .van-button{
                    float:right;
                    margin:15px;
                }
            }
        }
		
	}
</style>



// WEBPACK FOOTER //
// src/pages/VascularSystem/Expert/Record.vue